/* @indexer:no-export */

var cache = {};
function isCacheable(data) {
  return typeof data === 'object' && Object.keys(data).length === 1 && data._links;
}
export function getCacheKey(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return "".concat(url, "||").concat(method.toUpperCase());
}
export function addToCache(cacheKey, data) {
  if (isCacheable(data)) {
    cache[cacheKey] = data;
  }
}
export function existsInCache(cacheKey) {
  return cache.hasOwnProperty(cacheKey) && Object.keys(cache[cacheKey]).length;
}
export function getFromCache(cacheKey) {
  if (existsInCache(cacheKey)) {
    return cache[cacheKey];
  } else {
    return false;
  }
}